import * as React from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { usePendingStocksSearchParams } from 'hooks/store/pending-stocks';
import { useScheduleReport } from 'hooks/api/reports';
import { PageHeaderWithFilters } from 'components/ui/page-header-with-filters';
import { DataTable } from 'components/ui/DataTable';

import { useColumns, useFetchPendingStocks } from './hooks';
import { FiltersForm } from './components';

export const PendingStocks = () => {
  const { filters, updateFilters, clearState } = usePendingStocksSearchParams();
  const { fetchPendingStocks } = useFetchPendingStocks();
  const { scheduleReport } = useScheduleReport();
  const columns = useColumns();
  const navigate = useNavigate();

  const pendingStocksQuery = useQuery({
    queryKey: ['fetch-pending-stocks', filters],
    queryFn: () => fetchPendingStocks({ filters }),
  });

  const scheduleReportMutation = useMutation({
    mutationFn: scheduleReport,
    onSuccess: () => {
      toast('Relatório requisitado com sucesso');
      navigate('/relatorios/estoque-pendente-regularizacao');
    },
    onError: () => {
      toast.error('Erro ao requisitar relatório');
    }
  });

  const onRequestReport = React.useCallback((reportParams: Record<string, unknown>) => {
    scheduleReportMutation.mutate({
      type: 'pending-stocks',
      params: reportParams,
    });
  }, [scheduleReportMutation]);

  return (
    <>
      <PageHeaderWithFilters
        className={'mb-6'}
      >
        <FiltersForm
          onSubmitFilters={updateFilters}
          onResetFilters={clearState}
          onRequestReport={onRequestReport}
        />
      </PageHeaderWithFilters>
      <DataTable
        columns={columns}
        data={pendingStocksQuery?.data ?? []}
        isLoading={pendingStocksQuery.isLoading}
      />
    </>
  );
};
